import { v4 as uuidv4 } from 'uuid';

export function createNoFixtureToast() {
  return {
    id: uuidv4(),
    children: 'No fixtures found.',
  };
}

export function createNoDiffItemsToast() {
  return {
    id: uuidv4(),
    children: 'The provided ASINs either already exist in the plan or are not actionable.',
  };
}

export function bulkOperationWarning() {
  return {
    id: uuidv4(),
    children: 'Please ensure you are uploading the complete intended selection list.',
  };
}

export function createMissingFixtureDataToast(fixtureCount: number) {
  return {
    id: uuidv4(),
    children: `Found ${fixtureCount} fixtures missing dimensions or pos data.`,
  };
}

export function createFixtureAlreadyAssignedToast(fixtureId: string, zoneName: string) {
  return {
    id: uuidv4(),
    type: 'error' as const,
    children: `Fixture ${fixtureId} is already assigned to ${zoneName}`,
    dismissAfter: 5000,
  };
}

export function createNoCategoryToast(categoryLabel: string) {
  return {
    id: uuidv4(),
    type: 'warning' as const,
    children: `Choose a ${categoryLabel.toLowerCase()} for the active card before assigning fixtures.`,
    dismissAfter: 4000,
  };
}
